export const claimsAdviceBillingProviderHistoryColumns = [
  'id',
  'fk_claims_advice_meta_data_id',
  'billing_provider_entity_id',
  'billing_provider_name',
  'billing_provider_id_code_qualifier',
  'billing_provider_id_code',
  'billing_provider_ref_id_type',
  'billing_provider_ref_id',
  'billing_provider_addr_street_1',
  'billing_provider_addr_street_2',
  'billing_provider_addr_city',
  'billing_provider_addr_state',
  'billing_provider_addr_zip',
  'billing_provider_country_code',
  'billing_provider_country_subcode',
  'billing_provider_contact_id',
  'billing_provider_contact_name',
  'billing_provider_contact_type',
  'billing_provider_contact_phone',
  'delimiter',
  'trx_key',
  'meta_lineage_source_system_name',
  'meta_lineage_source_name',
  'meta_lineage_source_offset',
  'meta_load_dt',
  'meta_correlation_id',
  'meta_component',
  'snapshot_id',
];
